module.exports = __webpack_public_path__ + "img/banner.1cfabeb4.png";